import { useApiQuery } from './useApiQuery';
import { getCurrentUser } from '@/api/profile';
import type { UserProfile } from '@/api/profile';
import mockData from '@/data/mock-data.json';

const mockUser: UserProfile = {
  id: mockData.currentUser.id,
  keycloakSub: mockData.currentUser.objectId ?? '',
  firstName: mockData.currentUser.firstName,
  lastName: mockData.currentUser.lastName,
  email: mockData.currentUser.email,
  username: mockData.currentUser.username,
  phone: mockData.currentUser.phone,
  countryCode: mockData.currentUser.countryCode,
  mfaEmail: mockData.currentUser.mfaEmail,
  mfaVerified: mockData.currentUser.mfaVerified,
  createdAt: mockData.currentUser.createdAt,
  updatedAt: mockData.currentUser.createdAt,
};

export const useCurrentUser = () => {
  const { data, isLoading, error, isUsingMockData, reload } =
    useApiQuery<UserProfile>({
      queryFn: () => getCurrentUser(),
      mockData: mockUser,
    });

  return { user: data, isLoading, error, isUsingMockData, reload };
};
